import { Component } from '@angular/core';

@Component({
    standalone: false,
    selector: 'wl-settings-shell',
    template: `
        <abs-page-layout [pageTitle]="'GLOBAL.MENU_ITEMS.SETTINGS' | translate">
            <div class="settingsShell">
                <div class="sidebar desktop-only">
                    <wl-settings-menu></wl-settings-menu>
                </div>
                <div class="content">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </abs-page-layout>
    `,
    styles: [
        `
            :host {
                --wrapWidth: 1200px;
            }

            .settingsShell {
                display: flex;
                flex-direction: column;
            }

            @media screen and (min-width: 992px) {
                .settingsShell {
                    flex-direction: row;
                }

                .sidebar {
                    flex: 0 0 260px;
                    border-right: 1px solid rgba(0, 0, 0, 0.1);
                    padding-top: 16px;
                }

                .content {
                    flex: 1 1 auto;
                    min-width: 0;
                }
            }
        `
    ]
})
export class SettingsShellComponent {}
